import cc from 'classcat';
import { jsx } from 'react/jsx-runtime';
import { svgCls } from './styles/svg.js';

const TrefoilShape = ({
  fillColor = "currentColor",
  shapeRef,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  strokeColor,
  ...svgProps
}) => {
  return /*#__PURE__*/jsx("svg", {
    ...svgProps,
    className: cc([svgCls, svgProps.className]),
    ref: shapeRef,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 451.1 343.9",
    fill: fillColor,
    children: /*#__PURE__*/jsx("path", {
      d: "M345.1 120c-4.2-.2-7.6-3.7-7.6-8 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 4.3-3.3 7.8-7.6 8C44.2 123.3-3.2 176.1.2 237.9S56.3 347 118 343.7c45.6-2.5 85.1-32.4 99.9-75.6 1.4-4.2 6-6.4 10.2-5 2.3.8 4.2 2.6 5 5 20 58.5 83.7 89.7 142.2 69.7S465 254.1 445 195.6c-14.8-43.2-54.3-73.1-99.9-75.6z"
    })
  });
};

export { TrefoilShape };
//# sourceMappingURL=TrefoilShape.js.map
